module.exports = __webpack_public_path__ + "static/media/bnb-cvip.afdb6d55.png";